import React from 'react';
import { TooltipTrigger } from '@spark';
import '@/shared/styles/MappedValueHighlight.css';

/**
 * Inline highlight for a template value resolved from a mapped field
 * (Map prompt template "Show original text" / Model Configuration prompt
 * Preview): underlined text — brand color for dataset columns, success green
 * for custom / model-input fields — with a tooltip naming the source field.
 */
const MappedValueHighlight = ({ name, value, kind = 'column', ...rest }) => (
    <TooltipTrigger text={name} className="mapped-value-highlight__trigger">
        <span
            className={`mapped-value-highlight${kind === 'custom' ? ' mapped-value-highlight--custom' : ''}`}
            {...rest}
        >
            {value}
        </span>
    </TooltipTrigger>
);

export default MappedValueHighlight;
